// Modal component for displaying failed login attempts table
// Shows detailed failed login data in a modal overlay

import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Box
} from "@chakra-ui/react";
import FailedLoginsTable from "./FailedLoginsTable";

const FailedLoginsModal = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="6xl">
            <ModalOverlay />
            <ModalContent maxW="90%" maxH="90vh">
                <ModalCloseButton 
                    position="absolute" 
                    left="8px" 
                    right="auto" 
                    top="8px" 
                    zIndex="3" 
                />
                <ModalHeader>
                    ניסיונות כניסה כושלים - דוח מפורט
                </ModalHeader>
                <ModalBody pb={6} overflowY="auto">
                    <Box>
                        <FailedLoginsTable />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default FailedLoginsModal;
